import { render, staticRenderFns } from "./Kontakt.vue?vue&type=template&id=12b8a9df"
import script from "./Kontakt.vue?vue&type=script&lang=js"
export * from "./Kontakt.vue?vue&type=script&lang=js"
import style0 from "./Kontakt.vue?vue&type=style&index=0&id=12b8a9df&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports